






































































import mixins from 'vue-typed-mixins'
import DraftElement from '@/builder/sections/mixins/DraftElement'
import CCalendarEmployeePanel from '@/builder/sections/section/calendars/components/CCalendarEmployeePanel.vue'
import CCalendarLocationsPreview from '@/builder/sections/section/calendars/components/CCalendarLocationsPreview.vue'
import CCalendarServicesPreview from '@/builder/sections/section/calendars/components/CCalendarServicesPreview.vue'
import CCalendarSearchPreview from '@/builder/sections/section/calendars/components/CCalendarSearchPreview.vue'

export default mixins(DraftElement).extend({
  name: 'CCalendarPanels',
  components: {
    CCalendarEmployeePanel,
    CCalendarLocationsPreview,
    CCalendarServicesPreview,
    CCalendarSearchPreview
  },
  props: {
    expandCollapseServicePanels: {
      type: Boolean,
      default: false
    },
    serviceSelectionFirst: {
      type: Boolean,
      default: false
    },
    serviceSearchEnabled: {
      type: Boolean,
      default: false
    },
    locationSearchEnabled: {
      type: Boolean,
      default: false
    },
    employeeSearchEnabled: {
      type: Boolean,
      default: false
    },
    selectLocationsTitle: {
      type: String,
      default: ''
    },
    selectServicesTitle: {
      type: String,
      default: ''
    },
    selectEmployeesTitle: {
      type: String,
      default: ''
    },
    classForViewRound: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: null
    },
    textColor: {
      type: String,
      default: null
    },
    isSettingRandomEmployeeSupported: {
      type: Boolean,
      default: false
    }
  }
})
